import { render, staticRenderFns } from "./ColorGenerator.vue?vue&type=template&id=49aeb912"
import script from "./ColorGenerator.vue?vue&type=script&lang=js"
export * from "./ColorGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports